(function () {
  'use strict';

  var variantsEl = document.getElementById('scrub-variants-json');
  var imagesEl = document.getElementById('scrub-images-json');
  if (!variantsEl) return;

  var variants = JSON.parse(variantsEl.textContent);
  var variantImages = JSON.parse(imagesEl.textContent);

  var selectedColor = null;
  var selectedUpperSize = null;
  var selectedLowerSize = null;

  var mainImage = document.getElementById('scrub-main-image');
  var thumbs = document.querySelectorAll('.scrub-gallery__thumb');
  var colorSwatches = document.querySelectorAll('.scrub-swatch');
  var upperBtns = document.querySelectorAll('.scrub-size-btn[data-option="upper"]');
  var lowerBtns = document.querySelectorAll('.scrub-size-btn[data-option="lower"]');
  var priceEl = document.getElementById('scrub-price');
  var compareEl = document.getElementById('scrub-compare-price');
  var selectedColorEl = document.getElementById('selected-color');
  var selectedUpperEl = document.getElementById('selected-upper-size');
  var selectedLowerEl = document.getElementById('selected-lower-size');
  var atcBtn = document.getElementById('scrub-atc-btn');
  var qtyInput = document.getElementById('scrub-qty');
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');

  var basePriceCents = null; // tracks the current variant's own price, in cents

  // ---------------------------------------------------------------------
  // VARIANT / COLOR / SIZE LOGIC
  // ---------------------------------------------------------------------

  function findVariantByColor(color) {
    if (!color) return null;
    return variants.find(function(v) {
      return v.option1 === color || v.option2 === color || v.option3 === color;
    });
  }

  function findVariant() {
    if (!selectedColor || !selectedUpperSize || !selectedLowerSize) return null;
    return variants.find(function(v) {
      return v.option1 === selectedColor && v.option2 === selectedUpperSize && v.option3 === selectedLowerSize;
    }) || variants.find(function(v) {
      return v.option1 === selectedColor && v.option2 === selectedLowerSize && v.option3 === selectedUpperSize;
    });
  }

  function formatMoney(cents) {
    var formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
    return formatter.format(cents / 100);
  }

  function updatePrice(variant) {
    if (!variant || !priceEl) return;
    basePriceCents = variant.price;
    renderPrice();
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  // Renders base price + embroidery add-on together, so the displayed
  // price always reflects whatever embroidery is currently applied.
  function renderPrice() {
    if (basePriceCents === null || !priceEl) return;
    var embCents = (window.embroideryData && window.embroideryData.priceCents) || 0;
    priceEl.textContent = formatMoney(basePriceCents + embCents);

    var noteEl = document.getElementById('scrub-emb-price-note');
    if (noteEl) {
      if (embCents > 0) {
        noteEl.textContent = '+ ' + formatMoney(embCents) + ' embroidery';
        noteEl.classList.add('is-visible');
      } else {
        noteEl.classList.remove('is-visible');
      }
    }
  }

  function updateImage(variant) {
    if (!variant || !mainImage) return;
    var match = variantImages.find(function(v) { return v.variant_id === variant.id; });
    if (match) {
      mainImage.style.opacity = '0';
      setTimeout(function() {
        mainImage.src = match.image_src;
        mainImage.style.opacity = '1';
      }, 200);
    }
  }

  function updateATC() {
    var variant = findVariant();
    if (!variant) {
      var firstAvailable = variants.find(function(v) { return v.available; }) || variants[0];
      if (firstAvailable && !selectedColor && !selectedUpperSize && !selectedLowerSize) {
        atcBtn.dataset.variantId = firstAvailable.id;
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO CART';
        updatePrice(firstAvailable);
        updateImage(firstAvailable);
        return;
      }
      atcBtn.disabled = true;
      atcBtn.textContent = 'SELECT OPTIONS';
      return;
    }
    atcBtn.dataset.variantId = variant.id;
    if (!variant.available) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'SOLD OUT';
    } else {
      atcBtn.disabled = false;
      atcBtn.textContent = 'ADD TO CART';
    }
    updatePrice(variant);
    updateImage(variant);
  }

  function updateEmbColorBox(swatchEl) {
    var shirtBody = document.getElementById('emb-preview-shirt-body');
    var shirtCollar = document.getElementById('emb-preview-shirt-collar');
    if (!shirtBody || !swatchEl) return;
    var bg = swatchEl.style.backgroundColor;
    if (bg) {
      shirtBody.setAttribute('fill', bg);
      if (shirtCollar) shirtCollar.setAttribute('fill', bg);
    }
  }

  colorSwatches.forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      colorSwatches.forEach(function(s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      selectedColor = swatch.dataset.color;
      if (selectedColorEl) selectedColorEl.textContent = selectedColor;

      var colorVariant = findVariantByColor(selectedColor);
      if (colorVariant) {
        updateImage(colorVariant);
      }

      // Keep the embroidery popup's color box in sync with whichever
      // scrub color the customer currently has selected.
      updateEmbColorBox(swatch);

      updateATC();
    });
  });

  upperBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      upperBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedUpperSize = btn.dataset.value;
      if (selectedUpperEl) selectedUpperEl.textContent = selectedUpperSize;
      updateATC();
    });
  });

  lowerBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      lowerBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedLowerSize = btn.dataset.value;
      if (selectedLowerEl) selectedLowerEl.textContent = selectedLowerSize;
      updateATC();
    });
  });

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.style.opacity = '0';
        setTimeout(function() {
          mainImage.src = thumb.dataset.imageSrc;
          mainImage.style.opacity = '1';
        }, 200);
      }
    });
  });

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      if (val < 99) qtyInput.value = val + 1;
    });
  }

  // ---------------------------------------------------------------------
  // ADD TO CART (main product + hidden embroidery charge line item)
  // ---------------------------------------------------------------------

  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      var variantId = atcBtn.dataset.variantId;
      var qty = parseInt(qtyInput.value) || 1;
      if (!variantId) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'ADDING...';

      var properties = {};
      if (window.embroideryData && window.embroideryData.applied) {
        if (window.embroideryData.font_style_label) properties['Font Style'] = window.embroideryData.font_style_label;
        if (window.embroideryData.font_color_label) properties['Font Color'] = window.embroideryData.font_color_label;
        if (window.embroideryData.placement) properties['Text Placement'] = window.embroideryData.placement;
        if (window.embroideryData.line1) properties['Line 1'] = window.embroideryData.line1;
        if (window.embroideryData.line2) properties['Line 2'] = window.embroideryData.line2;
        if (window.embroideryData.line3) properties['Line 3'] = window.embroideryData.line3;
      }

      var items = [{ id: variantId, quantity: qty, properties: properties }];

      // Add the hidden "Embroidery Charge" variant as its own cart line,
      // so the extra cost shows as a real, separate line item at checkout.
      // We attach the chosen product/color/size as properties here too,
      // so the fulfillment team can see exactly which item this charge
      // belongs to without needing separate variants for every combination.
      //
      // IMPORTANT: chargeVariantId must be a valid, non-empty numeric ID.
      // If the merchant hasn't set up the "Embroidery Charge" product yet
      // (or left the variant ID setting blank), we must NOT push a bad
      // item into the request - Shopify rejects the entire /cart/add.js
      // call (including the main product) if any single line item is
      // invalid. So we validate strictly here and just skip the charge
      // line (with a console warning) rather than blocking the add.
      var chargeVariantId = window.embroideryData && window.embroideryData.chargeVariantId;
      var hasValidChargeVariant = chargeVariantId &&
        String(chargeVariantId).trim() !== '' &&
        !isNaN(Number(chargeVariantId)) &&
        Number(chargeVariantId) > 0;

      if (window.embroideryData && window.embroideryData.applied) {
        if (hasValidChargeVariant) {
          var chargeProps = {
            'For Product': (window.scrubProductTitle || document.title),
            'Color': selectedColor || '-',
            'Top Size': selectedUpperSize || '-',
            'Bottom Size': selectedLowerSize || '-',
            'Text Placement': window.embroideryData.placement || '-',
            'Lines': [window.embroideryData.line1, window.embroideryData.line2, window.embroideryData.line3]
              .filter(Boolean).join(' / ') || '-'
          };

          items.push({
            id: Number(chargeVariantId),
            quantity: qty,
            properties: chargeProps
          });
        } else {
          console.warn(
            'Embroidery was applied, but no valid "Embroidery Charge" variant ID is configured ' +
            'in the Embroidery block settings. The embroidery charge line item was skipped so the ' +
            'main product could still be added to cart. Set the Variant ID fields in the theme editor ' +
            'to enable the separate embroidery charge line.'
          );
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(errData) {
            throw new Error((errData && errData.description) || 'Cart add failed');
          });
        }
        return res.json();
      })
      .then(function() {
        var atcError = document.getElementById('scrub-atc-error');
        if (atcError) atcError.classList.remove('is-visible');
        atcBtn.textContent = 'ADDED ✓';
        atcBtn.style.background = '#1b4332';
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.textContent = 'ADD TO CART';
          atcBtn.style.background = '';
        }, 2000);
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO CART';
        var atcError = document.getElementById('scrub-atc-error');
        if (atcError) {
          atcError.textContent = 'Something went wrong. Please try again.';
          atcError.classList.add('is-visible');
        }
      });
    });
  }

  // ---------------------------------------------------------------------
  // TABS
  // ---------------------------------------------------------------------

  var tabBtns = document.querySelectorAll('.scrub-tab-btn');
  var tabPanels = document.querySelectorAll('.scrub-tab-panel');
  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      tabPanels.forEach(function(p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var target = document.getElementById('tab-' + btn.dataset.tab);
      if (target) target.classList.add('active');
    });
  });

  if (colorSwatches.length > 0) {
    colorSwatches[0].click();
  } else {
    updateATC();
  }

  // ---------------------------------------------------------------------
  // EMBROIDERY POPUP
  // ---------------------------------------------------------------------

  var embTrigger = document.getElementById('embroidery-trigger');
  var embPopup = document.getElementById('emb-popup');
  var embOverlay = document.getElementById('emb-overlay');
  var embClose = document.getElementById('emb-close');
  var embCancel = document.getElementById('emb-cancel');
  var embApply = document.getElementById('emb-apply');

  if (!embTrigger || !embPopup) return;

  var embConfigEl = document.getElementById('emb-config-json');
  var embConfig = embConfigEl ? JSON.parse(embConfigEl.textContent) : {
    price_1_2_lines: 1000,
    price_3_lines: 1500,
    variant_1_2_lines: null,
    variant_3_lines: null
  };

  var embSummary = document.getElementById('emb-summary');
  var embSummaryImg = document.getElementById('emb-summary-img');
  var embSummaryCost = document.getElementById('emb-summary-cost');
  var embSummaryFont = document.getElementById('emb-summary-font');
  var embSummaryColor = document.getElementById('emb-summary-color');
  var embSummaryPlacement = document.getElementById('emb-summary-placement');
  var embSummaryLines = document.getElementById('emb-summary-lines');
  var embSummaryEdit = document.getElementById('emb-summary-edit');
  var embSummaryRemove = document.getElementById('emb-summary-remove');

  var embLine1 = document.getElementById('emb-line1');
  var embLine2 = document.getElementById('emb-line2');
  var embLine3 = document.getElementById('emb-line3');
  var embCounter1 = document.getElementById('emb-counter1');
  var embCounter2 = document.getElementById('emb-counter2');
  var embCounter3 = document.getElementById('emb-counter3');
  var embFontStyle = document.getElementById('emb-font-style');
  var embFontColor = document.getElementById('emb-font-color');
  var embPlacement = document.getElementById('emb-placement');
  var embPopupPriceLabel = document.getElementById('emb-popup-price-label');

  var embPreviewLiveText = document.getElementById('emb-preview-live-text');
  var scrubOverlayText = document.getElementById('scrub-emb-overlay');

  function openEmb() {
    embOverlay.style.display = 'block';
    embPopup.style.display = 'block';
    setTimeout(function() {
      embOverlay.classList.add('open');
      embPopup.classList.add('open');
    }, 10);
    document.body.style.overflow = 'hidden';
    clearEmbError();
  }

  function closeEmb() {
    embOverlay.classList.remove('open');
    embPopup.classList.remove('open');
    setTimeout(function() {
      embOverlay.style.display = 'none';
      embPopup.style.display = 'none';
    }, 300);
    document.body.style.overflow = '';
  }

  embTrigger.addEventListener('click', openEmb);
  if (embClose) embClose.addEventListener('click', closeEmb);
  if (embCancel) embCancel.addEventListener('click', closeEmb);
  if (embOverlay) embOverlay.addEventListener('click', closeEmb);

  function setupCounter(input, counter) {
    if (!input || !counter) return;
    input.addEventListener('input', function() {
      counter.textContent = this.value.length + '/25';
      updateLivePreview();
    });
  }

  setupCounter(embLine1, embCounter1);
  setupCounter(embLine2, embCounter2);
  setupCounter(embLine3, embCounter3);

  // Builds the text block (joining filled lines) used by both the popup
  // preview and the main gallery image overlay.
  function buildPreviewText() {
    var lines = [embLine1, embLine2, embLine3]
      .map(function(el) { return el ? el.value.trim() : ''; })
      .filter(function(v) { return v.length > 0; });
    return lines.join('\n');
  }

  function applyTextStyles(el, fontFamily, color, placement) {
    if (!el) return;
    el.style.fontFamily = fontFamily || "'Brush Script MT', cursive";
    el.style.color = color || '#ffffff';
    el.setAttribute('data-placement', placement || 'Left Chest');
    // Left/right positioning is handled entirely by CSS via the
    // [data-placement] attribute on this element (absolute left/right %).
  }

  // Updates the popup's live preview as the user types/selects, in real time.
  function updateLivePreview() {
    var text = buildPreviewText();
    var fontFamily = embFontStyle ? embFontStyle.value : '';
    var color = embFontColor ? embFontColor.value : '';
    var placement = embPlacement ? embPlacement.value : '';

    if (embPreviewLiveText) {
      embPreviewLiveText.textContent = text;
      applyTextStyles(embPreviewLiveText, fontFamily, color, placement);
      if (text.length > 0) {
        embPreviewLiveText.classList.add('is-visible');
      } else {
        embPreviewLiveText.classList.remove('is-visible');
      }
    }

    // Live price label in the popup header, before Apply is even clicked
    var lineCount = [embLine1, embLine2, embLine3].filter(function(el) {
      return el && el.value.trim().length > 0;
    }).length;
    if (embPopupPriceLabel) {
      var liveCents = lineCount >= 3 ? embConfig.price_3_lines : embConfig.price_1_2_lines;
      embPopupPriceLabel.textContent = formatMoney(liveCents);
    }
  }

  if (embLine1) embLine1.addEventListener('input', updateLivePreview);
  if (embLine2) embLine2.addEventListener('input', updateLivePreview);
  if (embLine3) embLine3.addEventListener('input', updateLivePreview);
  if (embFontStyle) embFontStyle.addEventListener('change', updateLivePreview);
  if (embFontColor) embFontColor.addEventListener('change', updateLivePreview);
  if (embPlacement) embPlacement.addEventListener('change', updateLivePreview);

  function fontLabel(value) {
    if (!embFontStyle) return value;
    for (var i = 0; i < embFontStyle.options.length; i++) {
      if (embFontStyle.options[i].value === value) {
        return embFontStyle.options[i].textContent;
      }
    }
    return value;
  }
  function colorLabel(value) {
    if (!embFontColor) return value;
    for (var i = 0; i < embFontColor.options.length; i++) {
      if (embFontColor.options[i].value === value) {
        return embFontColor.options[i].textContent;
      }
    }
    return value;
  }

  // Renders the on-page summary card (Edit / Remove) once embroidery is applied.
  function renderSummary(data) {
    if (!embSummary) return;
    embSummaryCost.textContent = '(+ ' + formatMoney(data.priceCents) + ')';
    embSummaryFont.textContent = data.font_style_label;
    embSummaryColor.textContent = data.font_color_label;
    embSummaryPlacement.textContent = data.placement;
    var lines = [data.line1, data.line2, data.line3].filter(Boolean).join(', ');
    embSummaryLines.textContent = lines;

    if (embSummaryImg && mainImage) {
      embSummaryImg.src = mainImage.src;
      embSummaryImg.style.display = 'block';
    }

    embSummary.classList.add('is-visible');
    if (embTrigger) embTrigger.classList.add('is-hidden');
  }

  function clearSummary() {
    if (embSummary) embSummary.classList.remove('is-visible');
    if (embTrigger) {
      embTrigger.classList.remove('is-hidden');
      var span = embTrigger.querySelector('span');
      if (span) span.textContent = 'ADD TEXT EMBROIDERY';
    }
  }

  // Mirrors the applied embroidery text onto the main gallery image.
  function renderGalleryOverlay(data) {
    if (!scrubOverlayText) return;
    if (!data || !data.applied) {
      scrubOverlayText.classList.remove('is-visible');
      return;
    }
    var lines = [data.line1, data.line2, data.line3].filter(Boolean).join('\n');
    scrubOverlayText.textContent = lines;
    scrubOverlayText.style.fontFamily = data.font_style;
    scrubOverlayText.style.color = data.font_color;
    scrubOverlayText.setAttribute('data-placement', data.placement === 'Right Chest' ? 'right-chest' : 'left-chest');
    scrubOverlayText.classList.add('is-visible');
  }

  var embFormError = document.getElementById('emb-form-error');

  function showEmbError(message) {
    if (!embFormError) return;
    embFormError.textContent = message;
    embFormError.classList.add('is-visible');
  }

  function clearEmbError() {
    if (!embFormError) return;
    embFormError.textContent = '';
    embFormError.classList.remove('is-visible');
  }

  if (embApply) {
    embApply.addEventListener('click', function() {
      clearEmbError();

      var fsVal = embFontStyle.value;
      var fcVal = embFontColor.value;
      var plVal = embPlacement.value;
      var l1Val = embLine1 ? embLine1.value.trim() : '';

      if (!fsVal) { showEmbError('Please select a Font Style.'); return; }
      if (!fcVal) { showEmbError('Please select a Font Color.'); return; }
      if (!plVal) { showEmbError('Please select a Text Placement.'); return; }
      if (!l1Val) { showEmbError('Please enter at least Line 1.'); return; }

      var l2Val = embLine2 ? embLine2.value.trim() : '';
      var l3Val = embLine3 ? embLine3.value.trim() : '';

      var lineCount = [l1Val, l2Val, l3Val].filter(Boolean).length;
      var priceCents = lineCount >= 3 ? embConfig.price_3_lines : embConfig.price_1_2_lines;
      var chargeVariantId = lineCount >= 3 ? embConfig.variant_3_lines : embConfig.variant_1_2_lines;

      window.embroideryData = {
        applied: true,
        font_style: fsVal,
        font_style_label: fontLabel(fsVal),
        font_color: fcVal,
        font_color_label: colorLabel(fcVal),
        placement: plVal,
        line1: l1Val,
        line2: l2Val,
        line3: l3Val,
        priceCents: priceCents,
        chargeVariantId: chargeVariantId
      };

      renderSummary(window.embroideryData);
      renderGalleryOverlay(window.embroideryData);
      renderPrice();
      closeEmb();
    });
  }

  if (embSummaryEdit) {
    embSummaryEdit.addEventListener('click', function() {
      if (window.embroideryData) {
        if (embFontStyle) embFontStyle.value = window.embroideryData.font_style;
        if (embFontColor) embFontColor.value = window.embroideryData.font_color;
        if (embPlacement) embPlacement.value = window.embroideryData.placement;
        if (embLine1) { embLine1.value = window.embroideryData.line1; embCounter1.textContent = embLine1.value.length + '/25'; }
        if (embLine2) { embLine2.value = window.embroideryData.line2; embCounter2.textContent = embLine2.value.length + '/25'; }
        if (embLine3) { embLine3.value = window.embroideryData.line3; embCounter3.textContent = embLine3.value.length + '/25'; }
        updateLivePreview();
      }
      openEmb();
    });
  }

  if (embSummaryRemove) {
    embSummaryRemove.addEventListener('click', function() {
      window.embroideryData = { applied: false, priceCents: 0 };
      clearSummary();
      renderGalleryOverlay(null);
      renderPrice();
      if (embLine1) embLine1.value = '';
      if (embLine2) embLine2.value = '';
      if (embLine3) embLine3.value = '';
      if (embCounter1) embCounter1.textContent = '0/25';
      if (embCounter2) embCounter2.textContent = '0/25';
      if (embCounter3) embCounter3.textContent = '0/25';
      if (embFontStyle) embFontStyle.value = '';
      if (embFontColor) embFontColor.value = '';
      if (embPlacement) embPlacement.value = '';
      if (embPreviewLiveText) embPreviewLiveText.classList.remove('is-visible');
    });
  }

})();